import { makeStyles } from 'tss-react/mui';

export const TABLE_TOOLBAR_SEARCH_BAR_WIDTH = 280;
export const TABLE_TOOLBAR_SEARCH_BAR_MARGIN = 10;
export const TABLE_TOOLBAR_PADDING = 12;

const useStyles = makeStyles<{
  showAsTwoRows: boolean;
  isTwoRowViewport: boolean;
}>()((theme, { showAsTwoRows, isTwoRowViewport }) => ({
  toolbarContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',

    ...(!isTwoRowViewport && {
      padding: `${TABLE_TOOLBAR_PADDING}px`,
    }),

    ...(showAsTwoRows && {
      alignItems: 'flex-start',
    }),
  },
  leftColumnContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'flex-start',
    width: 'fit-content',

    ...(showAsTwoRows && {
      marginBottom: '8px',
    }),
  },
  rightColumnContainer: {
    justifyContent: 'end',
    alignItems: 'flex-start',
    width: 'fit-content',

    ...(showAsTwoRows && {
      width: '100%',
    }),
  },
  verticalDivider: {
    width: '1px',
    height: '48px',
    backgroundColor: theme.new.color.line.hairline,
    marginInline: '6px',
    alignSelf: 'center',
  },
}));

export default useStyles;
